import type { AbilityClass } from '@casl/ability'
import { Ability, AbilityBuilder } from '@casl/ability'

type Actions = 'index' | 'create' | 'edit' | 'delete'
type Subjects = 'division' | 'project' | 'application' | 'client' | 'user' | 'setting' | 'end-user'

export type AppAbility = Ability<[Actions, Subjects]>
export const AppAbilityClass = Ability as AbilityClass<AppAbility>

export function defineRules() {
  const { rules } = new AbilityBuilder(AppAbilityClass)
  return rules
}

export function buildAbility() {
  return new AppAbilityClass(defineRules(), {})
}
